<template>
    <div>
        <!-- <headLine></headLine> -->
        <global-tag>
            <span slot="title">联络历史</span>
            <div class="search" slot="search" ref="form" :model="form">
                <el-form label-width="90px">
                    <el-row :gutter="24">
                        <el-col :span="5">
                            <el-form-item label="对端号码：">
                                <el-input
                                    clearable
                                    placeholder="请输入"
                                    v-model="form.remoteNum"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="9">
                            <el-form-item label="日期：">
                                <el-date-picker
                                    style="width: 45%"
                                    v-model="form.startTimeStr"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    type="datetime"
                                    placeholder="请选择开始时间"
                                ></el-date-picker>
                                <span style="margin: 0 5px">至</span>
                                <el-date-picker
                                    style="width: 45%"
                                    v-model="form.endTimeStr"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    type="datetime"
                                    placeholder="请选择结束时间"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="是否小结：">
                                <el-select
                                    clearable
                                    placeholder="请选择"
                                    v-model="form.issummary"
                                >
                                    <el-option
                                        label="未小结"
                                        value="0"
                                    ></el-option>
                                    <el-option
                                        label="已小结"
                                        value="1"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="通话类型：">
                                <el-select
                                    clearable
                                    placeholder="请选择"
                                    v-model="form.outCall"
                                >
                                    <el-option
                                        label="呼入"
                                        value="0"
                                    ></el-option>
                                    <el-option
                                        label="呼出"
                                        value="1"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="5">
                            <el-form-item label="机构:">
                                <el-cascader
                                    :key="isRescourceShow"
                                    :options="orgTree"
                                    v-model="form.orgId"
                                    :show-all-levels="false"
                                    :props="{
                                        checkStrictly: true,
                                        emitPath: false,
                                        label: 'label',
                                        value: 'orgId',
                                    }"
                                    clearable
                                >
                                </el-cascader>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3" :offset="2">
                            <el-button
                                type="primary"
                                class="searchBtns"
                                @click="getlist"
                                >查询</el-button
                            >
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </global-tag>
        <div style="height: 20px"></div>
        <div>
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
            >
                <el-table-column
                    type="index"
                    width="70"
                    label="序号"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="loginName"
                    label="登录名"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="extNum"
                    label="坐席号"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="startTime"
                    label="来电时间"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <!-- <el-table-column prop="name" label="老人姓名" align="center">
                    <template slot-scope="scope">
                        <el-link
                            style="color: #038df5"
                            v-if="scope.row.name !== '未知来电'"
                            @click="seeInfor(scope.row)"
                        >
                            {{ scope.row.name }}
                        </el-link>
                        <span v-if="scope.row.name === '未知来电'">{{
                            scope.row.name
                        }}</span>
                    </template>
                </el-table-column> -->
                <el-table-column
                    prop="customerName"
                    label="姓名"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <el-link v-if="scope.row.customerName == null">
                            未知
                        </el-link>
                        <span v-if="scope.row.customerName != null">{{
                            scope.row.customerName
                        }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                    prop="agentID"
                    label="分机号码"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column> -->
                <el-table-column
                    prop="remoteNum"
                    label="对端号码"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="connectTimeLen"
                    label="通话时长"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="outCall"
                    label="通话类型"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.outCall == '1'">呼出</span>
                        <span v-if="scope.row.outCall == '0'">呼入</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="issummary"
                    label="通话小结"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.issummary == '0'">未小结</span>
                        <span v-if="scope.row.issummary == '1'">已小结</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            @click="summary(scope.row.callID, scope.row)"
                            >小结
                        </el-button>
                        <!--            <el-button v-if="scope.row.luyin" type="text" @click="sound(scope.row)">录音</el-button>-->
                        <!--            <el-button v-if="!scope.row.luyin" type="text" @click="stopplayer(scope.row)">暂停</el-button>-->
                        <el-button
                            type="text"
                            @click="downloadSound(scope.row)"
                            v-if="scope.row.connectTimeLen != '0'"
                            >下载</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <el-pagination
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :current-page.sync="pageNo"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                @size-change="handletableDataSize"
                @current-change="handleTableDataChange"
            ></el-pagination>
        </div>

        <!--弹窗-->
        <el-dialog
            :close-on-click-modal="false"
            title="话务小结"
            :visible.sync="dialogFormVisible"
            :modal-append-to-body="false"
            :before-close="onDialogClose"
            width="40%"
        >
            <el-form :model="summerForm" label-width="80px">
                <el-form-item label="通话类型">
                    <!-- <el-cascader
                        v-model="summerForm.region"
                        :options="summerTypeList"
                        :show-all-levels="false"
                    ></el-cascader> -->
                    <el-select v-model="summerForm.callType">
                        <el-option label="呼入" value="0"></el-option>
                        <el-option label="呼出" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="坐席姓名">
                    <el-input
                        disabled
                        v-model="summerForm.userName"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item label="通话小结">
                    <el-input
                        v-model="summerForm.remark"
                        type="textarea"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="onDialogClose">取 消</el-button>
                <el-button type="primary" @click="summerSubmit"
                    >确 定</el-button
                >
            </div>
        </el-dialog>
        <!--    录音弹框-->
        <el-dialog
            :before-close="musicDialogClose"
            title="录音听取"
            :visible.sync="music"
            :modal-append-to-body="false"
            :close-on-click-modal="false"
            width="35%"
        >
            <audio
                controls="controls"
                style="margin: 10px 25%"
                autoplay="autoplay"
                :src="audioSrc"
            ></audio>
        </el-dialog>
    </div>
</template>

<script>
let iantooMusic = new Audio()
import request from "@/utils/request.js"
import globalTag from "../components/globalTag"
import headLine from "../components/headline"
import { post } from "@/api/requrestHttp"
import request2 from "@/utils/request2.js"
import audioLink from "@/api/audio"
export default {
    components: {
        globalTag,
        headLine,
    },
    data() {
        return {
            form: {},
            provinceList: [], //省列表
            cityList: [], //市列表
            areaList: [], //区列表
            streetList: [], //街道列表
            communityList: [], //社区列表
            myMap: null, //地图
            tableData: [],
            pageSize: 10,
            total: 0,
            pageNo: 1,
            belongAddressId: "1856cf78-bd6a-45bf-afd4-b553f3da443f",
            isRescourceShow: 0,
            // 机构树
            orgTree: [],
            info: "",
            infoPhone: "",
            infor: false,
            summerTypeList: [],
            dialogFormVisible: false,
            summerForm: {
                remark: "",
                callType: "",
                loginName: "",
            },
            username: this.$store.state.info.name,
            clickType: "",
            clickId: "",
            ghocxIp: "192.168.5.5",
            music: false,
            audioSrc: "",
        }
    },
    created() {
        this.getOrgTree()
    },
    watch: {
        orgTree() {
            ++this.isRescourceShow
            console.log(this.isRescourceShow)
        },
    },
    mounted() {
        this.getlist()
        this.getProvince()
    },
    methods: {
        // 获取机构树
        async getOrgTree() {
            // const { content } = await post(
            //     "/rbac/admin/org/info/OrgTreeForOrgIdlist",
            //     {
            //         isValid: 1,
            //     }
            // )
            // this.orgTree = content;

            this.$post("/rbac/admin/org/info/OrgTreelist", { isValid: 1 }).then(
                (res) => {
                    if (res.code === 200) {
                        //当前账号绑定的机构所有下级
                        let treeList = []
                        this.orgTree = this.chbehavior(
                            res.content,
                            this.$store.state.info.orgId
                        )
                        if (!this.orgTree.children) {
                            //当前账号绑定的机构下级&自己数据
                            treeList.push({
                                label: this.orgTree.label,
                                orgId: this.orgTree.orgId,
                            })
                            this.orgTree = treeList
                        } else {
                            treeList.push({
                                label: this.orgTree.label,
                                orgId: this.orgTree.orgId,
                                children: this.orgTree.children,
                            })
                            this.orgTree = treeList
                        }
                    }
                }
            )
        },
        chbehavior(arr, id) {
            let res
            ;(function deepId(arr, id) {
                for (let a of arr) {
                    if (a.orgId == id) {
                        res = a
                    } else if (a.children && !res) {
                        deepId(a.children, id)
                    }
                }
            })(arr, id)
            return res
        },
        stopplayer(row) {
            // 停止播放音频
            row.luyin = true
            // this.music=false
            iantooMusic.pause()
        },
        async downloadSound(row) {
            request({
                url: "/jjyl/trafficRecFile/info/get",
                method: "POST",
                data: {
                    callID: row.callID,
                },
                //responseType: "blob",
            }).then((res) => {
                if (res.code == "200") {
                    // window.open(audioLink + "/" + res.content.fileName)
                    window.location.href =
                        audioLink + "/" + res.content.fileName
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 录音弹框关闭
        musicDialogClose() {
            this.music = false
            this.audioSrc = ""
        },
        // 显示录音弹框
        sound(row) {
            // 开始播放音频
            if (row.fileName) {
                window.console.log(row.fileName)
                this.music = true
                row.luyin = false
                this.audioSrc =
                    "http://" +
                    this.ghocxIp +
                    "/downbyname.php?name=" +
                    row.fileName
            } else {
                this.$message(row.fileName + "文件不存在")
            }
        },
        // 话务小结提交
        summerSubmit() {
            if (this.summerForm.callType && this.summerForm.remark) {
                //this.metaDataMgrDaos()
                this.submitSummer()
            } else {
                this.$message.error("请将信息填写完整！")
            }
        },
        // 话务小结弹窗关闭
        onDialogClose() {
            this.dialogFormVisible = false
            this.username = ""
            this.summerTypeList = []
            this.summerForm = {}
            this.clickType = ""
            this.clickId = ""
        },
        // 分页切换
        handletableDataSize(val) {
            this.pageSize = val
            this.getlist()
        },
        // 分页切换
        handleTableDataChange(val) {
            this.pageNo = val
            this.getlist()
        },
        //获取表格数据列表
        getlist() {
            this.$http
                .request({
                    url: "/jjyl/traffic/callInfo/info/findCallHistoryList",
                    method: "POST",
                    data: {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        ...this.form,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content && res.content.list) {
                            this.tableData = res.content.list
                            this.total = res.content.count
                        } else {
                            this.tableData = []
                            this.total = 0
                        }
                    }
                })
        },
        // 显示话务小结弹窗
        summary(id, row) {
            this.info = []
            this.infoShow = false
            this.clickId = id
            this.callmanid = row.loginId
            // if (type == 0) {
            //     //  呼入
            //     this.summerForm.region = "呼入工单回访"
            // } else if (type == 1) {
            //     //  呼出
            //     this.summerForm.region = "呼出工单回访"
            // }
            this.dialogFormVisible = true
            this.summerForm.callType = row.outCall
            this.summerForm.userName = row.userName
            this.summerForm.remark = row.remark
            //this.getFindReturnTree()
            // this.getCallsummary()
        },
        submitSummer() {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            })
            request({
                url: "/jjyl/callSummary/info/update",
                method: "POST",
                data: {
                    callid: this.clickId,
                    calltype: this.summerForm.callType,
                    remark: this.summerForm.remark,
                    callmanid: this.callmanid,
                    callman: this.summerForm.loginName,
                    userName: this.summerForm.userName,
                },
            }).then((resp) => {
                if (resp.code == "200") {
                    loading.close()
                    this.dialogFormVisible = false
                    this.$message({
                        message: resp.message,
                        type: "success",
                    })
                    this.dialogFormVisible = false
                    this.summerForm.remark = ""
                    this.getlist()
                } else if (resp.code == "500") {
                    this.$message("系统异常，请稍后重试")
                    this.tableData = this.tableData.concat(null)
                    this.loading = false
                    loading.close()
                }
            }).catch((error) => {
                this.dialogFormVisible = false
                loading.close()
            })
        },
        //获取通话类型
        // getFindReturnTree() {
        //     request({
        //         url: "/jjyl/return/info/findReturnTree",
        //         method: "POST",
        //         data: {
        //             isCall: 1,
        //             // username: this.$store.state.info.name,
        //             username: "南京分公司",
        //             outCall: this.clickType,
        //             belongAddressId: "1856cf78-bd6a-45bf-afd4-b553f3da443f",
        //         },
        //     }).then((resp) => {
        //         if (resp.code == "200") {
        //             if (resp.content != null) {
        //                 console.log(resp)
        //                 let arry = []
        //                 resp.content.sublist.forEach((item) => {
        //                     let obj = {}
        //                     if (item.sublist) {
        //                         let subArr = []
        //                         item.sublist.forEach((items) => {
        //                             let subobj = {
        //                                 value: items.name,
        //                                 label: items.name,
        //                             }
        //                             subArr.push(subobj)
        //                         })
        //                         obj = {
        //                             value: item.name,
        //                             label: item.name,
        //                             children: subArr,
        //                         }
        //                     } else {
        //                         obj = {
        //                             value: item.name,
        //                             label: item.name,
        //                         }
        //                     }
        //                     arry.push(obj)
        //                 })
        //                 console.log(arry)
        //                 this.summerTypeList = arry
        //             } else {
        //                 this.$message("暂无数据")
        //                 console.log(resp)
        //             }
        //         } else if (resp.code == "500") {
        //             this.$message("系统异常，请稍后重试")
        //             this.tableData = this.tableData.concat(null)
        //             this.loading = false
        //         } else {
        //             this.$alert("认证失败，重新登录！", "系统提示", {
        //                 confirmButtonText: "确定",
        //                 cancelButtonText: "取消",
        //                 type: "warning",
        //                 callback: (action) => {
        //                     this.$router.push({ path: "/login" })
        //                 },
        //             })
        //         }
        //     })
        // },
        //获取地址
        getDistrict(name = "中国", params = null) {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1, //返回下一级行政区
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                    city: "", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                })
                try {
                    self.myMap.remove(self.marker)
                } catch (err) {
                    console.log(err)
                }
                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                        if (this.isMap) {
                            this.isMap = false
                            return
                        }
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },
        //获取省级
        async getProvince() {
            this.provinceLis = []
            this.cityList = []
            this.areaList = []
            this.streetList = []
            let province = await this.getDistrict()
            this.provinceList = province.districtList
        },
        //  省级地址选择发生改变
        async handleProvince(val) {
            this.cityList = []
            this.areaList = []
            this.streetList = []
            this.communityList = []
            this.form.cityid = ""
            this.form.zoneid = ""
            this.form.streetid = ""
            this.form.shequid = ""
            this.form.address = ""
            let city = await this.getDistrict(val)
            this.cityList = city.districtList
        },
        //市级地址发生改变
        async handleCity(val) {
            this.areaList = []
            this.streetList = []
            this.communityList = []
            this.form.zoneid = ""
            this.form.streetid = ""
            this.form.shequid = ""
            this.form.address = ""
            let area = await this.getDistrict(val)
            this.areaList = area.districtList
        },
        //县区级地址发生改变
        async handleArea(val) {
            this.streetList = []
            this.communityList = []
            this.form.streetid = ""
            this.form.shequid = ""
            this.form.address = ""
            // val = val.replace(/.$/, "");
            let street = await this.getDistrict(val)
            this.streetList = street.districtList
        },
        //街道地址发生变化
        streetChange(val, flag = null) {
            this.communityList = []
            if (!flag) {
                this.form.shequid = ""
            }
            this.$http
                .request({
                    url: "/ypt/admin/standardAddress/info/StandardAddressTree",
                    method: "POST",
                    data: {
                        pageSize: 1000,
                        pageNo: 1,
                        jiedaoId: val,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.communityList = []
                            return
                        }
                        this.communityList = res.content.list
                    }
                })
        },

        // 查看信息
        seeInfor(row) {
            console.log(row.remoteNum)
            this.infoId = row.id
            this.infoPhone = row.remoteNum
            this.infor = true
        },
    },
}
</script>

<style scoped lang='less'>
/deep/.el-input__suffix {
    margin-top: 0px;
}
</style>
